// Native Web Crypto SHA-256 — replaces the previous js-sha256 dependency
// (~18 KB raw / ~5 KB gzipped). All browsers in our supported browserslist
// expose `crypto.subtle.digest`, so no polyfill is needed.
//
// `crypto.subtle.digest` is async and returns an ArrayBuffer of the raw
// hash bytes; we base64-encode it to match the previous output format
// (Uint8Array → String.fromCharCode → btoa).

async function hashSHA256(message) {
    if (!message) {
        return undefined;
    }

    const data = new TextEncoder().encode(message);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    const hashBytes = new Uint8Array(hashBuffer);
    return btoa(String.fromCharCode.apply(null, hashBytes));
}

module.exports = {
    hashSHA256
};
